module.exports = __webpack_public_path__ + "img/services-01.f94140c8.png";